import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { Component, effect, inject, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { dsDtos as dsDtosAdmin } from '@vectronic/openApi-admin';
import { dsDtos as dsDtosCustomer, webDtos } from '@vectronic/openApi-customer';
import { TrackplayCalculationService } from './trackplay-calculation.service';
import { TrackplayService } from './trackplay.service';

@Component({
  selector: 'bm-trackplay',
  imports: [MatCardModule, FormsModule, MatIconModule, NgxSliderModule, MatTooltip],
  providers: [TrackplayService, TrackplayCalculationService],
  templateUrl: './trackplay.component.html',
  styleUrl: './trackplay.component.scss',
})
export class TrackplayComponent {
  public trackplayService = inject(TrackplayService);

  mapPositions = input<webDtos.MapPositionsList[]>();
  speciesMap = input<Map<number, dsDtosCustomer.AnimalSpecies | dsDtosAdmin.AnimalSpeciesInput>>();
  autoFocusEnabled = input<boolean>();

  isBottomMenuHidden = output<boolean>();
  autoFocusToggled = output<boolean>();

  private updateTrackplayServiceInputEffect = effect(() => {
    this.trackplayService.mapPositions = this.mapPositions();
    this.trackplayService.speciesMap = this.speciesMap();
    this.trackplayService.onInputsChanged();
  });

  private syncAutoFocusStateEffect = effect(() => {
    const autoFocusEnabled = this.autoFocusEnabled();
    if (autoFocusEnabled === undefined) return;
    this.trackplayService.updateAutoFocus(autoFocusEnabled);
  });

  toggleAutoFocus(): void {
    this.trackplayService.toggleAutoFocus();
    this.autoFocusToggled.emit(this.trackplayService.defaultConfig.autoFocus);
  }

  toggleBottomMenuVisibility() {
    this.isBottomMenuHidden.emit(false);
  }
}
